import { render, staticRenderFns } from "./workAddress.vue?vue&type=template&id=a225dc14&scoped=true&"
import script from "./workAddress.vue?vue&type=script&lang=js&"
export * from "./workAddress.vue?vue&type=script&lang=js&"
import style0 from "./workAddress.vue?vue&type=style&index=0&id=a225dc14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a225dc14",
  null
  
)

export default component.exports